import sagaMiddlewareFactory from 'redux-saga';
import { persistStore } from 'redux-persist';
import { createStore, applyMiddleware, compose } from 'redux';

import { rootSaga } from './rootSaga';
import { rootReducer } from './rootReducer';

const sagaMiddleware = sagaMiddlewareFactory();

const composeEnhancers =
  window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__?.({
    name: 'Stickies Dashboard',
  }) || compose;

const store = createStore(rootReducer, composeEnhancers(applyMiddleware(sagaMiddleware)));
const persistor = persistStore(store, null);

sagaMiddleware.run(rootSaga);

export { store, persistor };
